module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/8-9e67fbf220c07cb936f678b4d59a275e.jpg";